import { useEffect, useState } from 'react';

import type { CloudeqEntity } from '@clm/shared-types';

import { listCloudeqEntities } from '../api/cloudeq-entity';

/**
 * The cloudEQ entity registry, loaded once per mount — CLM-91 (D-91-2, D-91-5).
 *
 * The three selects (Analytics Overview, Dashboard, Search) and the Contract
 * record's override take their options from the API's five registry rows, in
 * `sort_order`, never from a constant: the fifth entity's name is still to be
 * confirmed (Q-91-1) and a `0096` data migration corrects it without a web
 * deploy. A failed read leaves the list empty — the select still offers
 * "All cloudEQ entities" and the board renders; the read is `contract:read`,
 * which every CLM role holds, so a failure here is the board's own problem
 * banner's to explain, not this hook's.
 */
export function useCloudeqEntities(): readonly CloudeqEntity[] {
  const [entities, setEntities] = useState<readonly CloudeqEntity[]>([]);

  useEffect(() => {
    const controller = new AbortController();
    void listCloudeqEntities(controller.signal).then(
      (response) => {
        if (!controller.signal.aborted) setEntities(response.entities);
      },
      () => {
        /* Left empty on purpose — see the header. */
      },
    );
    return () => {
      controller.abort();
    };
  }, []);

  return entities;
}
